export default "__VITE_ASSET__DdEDcD_8__"